const e = {
  textTransform: "capitalize"
}, t = {
  textTransform: "uppercase",
  letterSpacing: "2px"
}, a = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};
export {
  e as capitalizeStyles,
  a as truncateStyles,
  t as uppercaseStyles
};
